import type { PressReleaseNodeProps } from '@commons/pagebuilder/nodes/PressRelease';
import type { DrupalView } from '@commons/types/drupal';

import CardsDisplay from './Cards';

/**
 * Enum of displays for the press release view.
 */

export enum PRESS_RELEASE_VIEW_DISPLAY {
  Card = 'card_block',
}

/**
 * Type definition for the press release view.
 */

export type DrupalPressReleaseView = DrupalView<PressReleaseNodeProps>;

/**
 * Press release view component.
 *
 * For now, only the cards display is supported.
 */

const PressReleaseView = (props: DrupalPressReleaseView) => {
  switch (props.display) {
    default:
    case PRESS_RELEASE_VIEW_DISPLAY.Card:
      return <CardsDisplay {...props} />;
  }
};

export default PressReleaseView;
